export default "<notification-messages [bucket]=\"messageBucketId\"></notification-messages>\n";